import { ErrorMessage } from "@/app/components/error-message";
import { LoadingScreen } from "@/components/loading-screen";
import { useGetOrganisation } from "@/features/organisations/api/get-organisation";
import { OrganisationAddressForm } from "@/features/organisations/components/organisation-address.form";
import { OrganisationBrandingForm } from "@/features/organisations/components/organisation-branding.form";
import { OrganisationContactDetailsForm } from "@/features/organisations/components/organisation-contact-details.form";
import { OrganisationDetailsForm } from "@/features/organisations/components/organisation-details.form";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";

export function OrganisationDetailsPage() {
  const { organisation } = useOrganisation();
  const { data, isLoading, isSuccess, isError, error } = useGetOrganisation({
    id: organisation.id,
  });

  if (isLoading)
    return (
      <div>
        <OnboardingHeader
          title="Organisation Details"
          description="View and manage Organisation details"
          className="mb-6"
        />
        <LoadingScreen />
      </div>
    );

  if (isError || !isSuccess)
    return (
      <div>
        <OnboardingHeader
          title="Organisation Details"
          description="View and manage Organisation details"
          className="mb-6"
        />
        <ErrorMessage error={error} />
      </div>
    );

  return (
    <div>
      <OnboardingHeader
        title="Organisation Details"
        description="View and manage Organisation details"
        className="mb-6"
      />

      <div className="space-y-6">
        <OrganisationDetailsForm initialData={data} />
        <OrganisationBrandingForm initialData={data} />
        <OrganisationContactDetailsForm initialData={data} />
        <OrganisationAddressForm initialData={data} />
      </div>
    </div>
  );
}
